import { Provider } from "react-redux";
import Head from "next/head";
import Image from "next/image";
import { useRouter } from "next/router";
import { ToastContainer } from "react-toastify";
import ResponsiveAppBar from "components/appbar/ResponsiveAppBar";
import MobileAppBar from "components/appbar/MobileAppBar";
import Footer from "components/footer/Footer";
import { store } from "redux-toolkit/store";
import useAuth from "hooks/auth/useAuth";
import ThemeProvider from "../theme";
import Loading from "components/common/Loading";
import "styles/globals.css";

export default function App({ Component, pageProps }) {
  const router = useRouter();
  const { currentUser, isLoading, signOut } = useAuth();

  return (
    <Provider store={store}>
      <ThemeProvider>
        <Head>
          <title key="title">Պրոգնոզ</title>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="icon" href="/logo.svg" />
        </Head>
        <ResponsiveAppBar
          currentUser={currentUser}
          isLoading={isLoading}
          signOut={signOut}
        />
        <MobileAppBar />
        <div
          style={{ fontFamily: "Noto Sans Armenian" }}
          className="relative min-h-screen"
        >
          {/* Global Cyber Grid Overlay */}
          <div
            className="fixed inset-0 z-[-1] opacity-[0.08]"
            style={{
              backgroundImage:
                "linear-gradient(rgba(102,133,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(102,133,255,0.1) 1px, transparent 1px)",
              backgroundSize: "60px 60px",
            }}
          />
          <div className="fixed inset-0 z-[-1] bg-[#030014] pointer-events-none" />

          <div
            className={
              router.pathname === "/"
                ? ""
                : "h-max-screen md:px-[124px] pb-12 pt-[60px]" // extra padding since appbar is absolute/fixed transparent now
            }
          >
            <Component {...pageProps} />
          </div>
        </div>

        <Footer
          currentUser={currentUser}
          isLoading={isLoading}
          signOut={signOut}
        />
        <ToastContainer />
      </ThemeProvider>
    </Provider>
  );
}
